
<template>

  <div >
    <t-back-button :to="{name:'ThinksPage'}" />
    <!-- <router-link　class="back" :to="{name:'ThinksPage'}"><i class="fas fa-chevron-left"></i><ruby><rb>戻</rb><rt>もどる</rt></ruby>る</router-link> -->

    <!-- <span @click="isVisibleSideList = !isVisibleSideList">サイドリスト表示</span> -->
    <!-- {{thinkID}} -->
    <div class="wordpage-container">
      <div v-if="isVisibleSideList" class="side-container">
       <tthink-list-component Mode="side-menu" v-on:selectThink ="SelectThink"></tthink-list-component>
      </div>
      <div class="main-container" v-if="thinkData.id !== undefined">
        <title-component :title="thinkData.title"></title-component>
        <words-component v-on:selectWord ="NavigateTo" style="margin-top:10px;"></words-component>
      </div>
    </div>

  </div>
</template>

<script>
import Title from "../atoms/Title";
import Words from "../Words";
import ThinkList from "../ThinkList";
import TBackButton from "../atoms/TBackButton";
export default {
  name: "WordsPage",
  components: {
    "title-component": Title,
    "words-component": Words,
    "tthink-list-component":ThinkList,
    TBackButton
  },
  data() {
    return {
      isVisibleSideList:false//サイドバー表示
    };
  },
  props:{thinkID:String},
  mounted() {
   
    //Notice: storeのthinkDataがセットされていない場合
    //1.think一覧を取得
    //2.現在のthinkIDと照合するかチェック
    //3.照合する＝StoreにSetThinkし、GetWordsを実行
    //3.照合NG = thinkpageへリダイレクト
    if (this.thinkData.id === undefined) {
      var callback = function(result,msg) {
        if(result === false)
        {
          alert(msg)
          return;
        }
        var items = this.$store.getters.thinkItems;
        var itemsCount = items.length;
        for(var i = 0; i < itemsCount; i++) {
          if(items[i].id=== this.thinkID)
          {
            //照合OK:選択
             this.$store.commit("SetThink", items[i]);

             //選択したデータの[Words]を取得する
             this.GetWords();
             return;
          }
        }

        //照合NG
        //データが存在しない場合はthinkpageへリダイレクト
         if (this.thinkData.id === undefined) {
            this.$router.push({ path: "/thinkpage" });
            return;
        }
      }.bind(this);

      //1.think一覧を取得
      this.$store.dispatch("GetThinks",{callback:callback});
    }

  },
  computed: {
    thinkData() {
      return this.$store.getters.thinkData;
    }
  },
  methods: {
    NavigateTo(item) {
      this.$store.commit("SetActiveWord", item);
      //ページ遷移
      this.$router.push({ name: "TThinkPage",params:{wordID:item.id,thinkID:this.thinkID} });
    },
    SelectThink(item){

      this.thinkID = item.id;
      this.$router.replace({ name: "WordsPage",params:{thinkID:item.id} })//URLのパラメータを書き換える処理
      //選択したデータをストアにセット
      this.$store.commit("SetThink", item);

      
      //選択したデータの[Words]を取得する
      this.GetWords();
     
    },
    GetWords(){
        var callback = function(result,msg) {
          
        }
        this.$store.dispatch("GetWords",{callback:callback});
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.from = from.path;
      // Notice: thinkpageからの遷移のみデータを取得する
      // ＊不必要にデータを取得して、リストのちらつきをおさえるのが目的
      if (from.path === "/thinkpage") {

        vm.GetWords();
       
      }
       
    });
  },
  beforeRouteLeave(to, from, next) {
    if (to.path === "/thinkpage") {
      this.$store.commit("SetWords", []);
    }
    next();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
//--------------
.wordpage-container{
  display: flex;
  padding-bottom: 30px;
  

  .side-container{
    margin-right:10px;
    width:400px;
  }


  .main-container{
    width:100%;

  }

}

//================
//戻るボタン
//================
.back {
  text-align: left;
  padding-left: 5px;
  display: inline-block;
  font-size: 22px;
  text-decoration: none;
  margin-bottom: 8px;
  & > i {
    margin-right: 8px;
  }
  &:hover {
    color: coral;
  }
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/WordsPage.vue